import { render } from "./IconBiotech.vue?vue&type=template&id=42dd9796"
import script from "./IconBiotech.vue?vue&type=script&lang=js"
export * from "./IconBiotech.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__